import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const useAccountLinks = () => {
  const { user, church, isAdmin } = useAuth();
  const [results, setResults] = useState([]);
  useEffect(() => {
    if (user) api.get("/me/results").then((r) => setResults(r.data)).catch(() => setResults([]));
  }, [user]);
  if (!user) return null;
  const paid = church?.billing?.can_collect;
  const links = [];
  if (church && paid) links.push(["/dashboard", "Dashboard", "dashboard"]);
  if (church) links.push(["/billing", "Manage subscription", "billing"]);
  else links.push(["/onboarding", "Choose a plan", "choose-plan"]);
  if (isAdmin) links.push(["/admin/codes", "Platform admin", "platform-admin"]);
  results.slice(0, 3).forEach((r) => links.push([`/r/${r.volunteer_id}`, `My results · ${r.church_name}`, `result-${r.volunteer_id}`]));
  return { user, links };
};
